import React from 'react';

const Skills = () => {
    return (
        <div id='skill' className=''>
            <h1 className='text-5xl text-center my-5'
            data-aos="fade-down"
            data-aos-duration="1000"
            data-aos-easing="ease-out-left"
            data-aos-mirror="true"
            >Skills</h1>

<div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mx-10 mb-20'>
            
            {/* javascript */}
            <div className="card w-full mx-auto bg-gradient-to-r from-indigo-800 to-indigo-600 shadow-xl"
            data-aos="fade-right"
            data-aos-duration="1500"
            data-aos-easing="ease-out-left"
            data-aos-mirror="true"
            >
            <figure className='flex justify-center items-center'><img className=' w-24 pt-3' src="https://cdn-icons-png.flaticon.com/512/919/919828.png?w=740&t=st=1674577796~exp=1674578396~hmac=9f7c85c923211968cdb8f0d8d8c88fdc6019a3e1f5e51e029890d62dda38fd2f" alt="car!"/></figure>
            <div className="card-body text-white text-xl">
                <h2 className="card-title text-4xl">JavaScript</h2>
                <li>Can solve problems</li>
                <li>Good at DOM</li>
                <li>Know Core Functions</li>
            </div>
            </div>
            {/* react js */}
            <div className="card mx-auto w-full bg-gradient-to-r from-indigo-800 to-indigo-600 shadow-xl"
            data-aos="fade-down"
            data-aos-duration="1500"
            data-aos-easing="ease-out-left"
            data-aos-mirror="true"
            >
            <figure className='flex justify-center items-center'><img className=' w-32 py-6' src="https://cdn-icons-png.flaticon.com/512/1250/1250291.png?w=740&t=st=1674578979~exp=1674579579~hmac=ebb521466c34b1c2b685c8fae9b375b70b4eca04393dcb1e1df0091a62d51394" alt="car!"/></figure>
            <div className="card-body text-white text-xl">
                <h2 className="card-title text-4xl">React JS</h2>           
                <li>React Core things and components</li>
                <li>Good at React-Router</li>
                <li>NPM GIT JSX and More</li>
            </div>
            </div>
            {/* Node js */}
            <div className="card w-full mx-auto bg-gradient-to-r from-indigo-800 to-indigo-600 shadow-xl"
            data-aos="fade-left"
            data-aos-duration="1500"
            data-aos-easing="ease-out-left"
            data-aos-mirror="true"
            >
            <figure className='flex justify-center items-center'>
                <img className=' w-32 py-6' src="https://cdn-icons-png.flaticon.com/128/5968/5968322.png" alt="car!"/></figure>
            <div className="card-body text-white text-xl">
                <h2 className="card-title text-4xl">Node js</h2>
                <li>Package Management</li>
                <li>Databases and Node JS NPM</li>
                <li>Source & Security</li>
            </div>
            </div>
            {/* Express js */}
            <div className="card w-full mx-auto bg-gradient-to-r from-indigo-800 to-indigo-600 shadow-xl"
            data-aos="fade-right"
            data-aos-duration="1500"
            data-aos-easing="ease-out-left"
            data-aos-mirror="true"
            >
            <figure className='flex justify-center items-center'><img className='
             w-32 py-6' src="https://i.ibb.co/Tkz6cpN/images-removebg-preview.png" alt="car!"/></figure>
            <div className="card-body text-white text-xl">
                <h2 className="card-title text-4xl">Express JS</h2>
                <li>Done Concept</li>
                <li>Good at Express</li>
                <li>Core things</li>
            </div>
            </div>
            {/* MongoDB */}
            <div className="card w-full mx-auto bg-gradient-to-r from-indigo-800 to-indigo-600 shadow-xl"
            data-aos="fade-up"
            data-aos-duration="1500"
            data-aos-easing="ease-out-left"
            data-aos-mirror="true">
            <figure className='flex justify-center items-center'><img className='  w-32 py-6' src="https://cdn-icons-png.flaticon.com/128/892/892917.png" alt="car!"/></figure>
            <div className="card-body text-white text-xl">
                <h2 className="card-title text-4xl">MongoDB</h2>
                <li>MongoDb Essential</li>
                <li>Performance</li>
                <li>Data Security</li>
            </div>
            </div>
            {/* Mern Stack */}
            <div className="card w-full mx-auto bg-gradient-to-r from-indigo-800 to-indigo-600 shadow-xl"
            data-aos="fade-left"
            data-aos-duration="1500"
            data-aos-easing="ease-out-left"
            data-aos-mirror="true"
            >
            <figure className='flex justify-center items-center'><img className='  w-52 py-6' src="https://qph.fs.quoracdn.net/main-qimg-073ea8b86447ed9310e7e73bd89894b3" alt="car!"/></figure>
            <div className="card-body text-white text-xl">
                <h2 className="card-title text-4xl">Mern Stack</h2>
                <li>Whole things</li>
                <li>Best in MERN</li>
                <li>Projects</li>
            </div>
            </div>
        </div>
        </div>
    );
};

export default Skills;